function externalUrl(event) {
    if (dragging) return;

    var target = event.target.closest("a[href^='http']:not(.proceed):not([data-lightbox])");
    if (target) {
        var targetHref = target.getAttribute("href");
        var reg = new RegExp(document.location.host);

        if (!reg.test(targetHref) && !allowedExternalUrls.test(targetHref)) {
            event.preventDefault();

            var modal = document.getElementById("speedbump-modal");
            document.body.classList.add("is-loading");
            modal.classList.add("is-shown");
            modal.querySelector(".proceed").setAttribute("href", targetHref);
        }
    }
}

function closeSpeedbumpModal(event) {
    if (dragging) return;

    var modal = document.getElementById("speedbump-modal");

    // Close button, prevent default and close modal
    var target = event.target.closest("#speedbump-modal .close");
    if (target) {
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove("is-loading");
        modal.classList.remove("is-shown");
    } else {
        // Proceed button, just close modal
        var target = event.target.closest("#speedbump-modal .proceed");
        if (target) {
            event.stopPropagation();

            console.log('target touched:');
            console.log(target.href);

            setTimeout(()=>{
                document.body.classList.remove("is-loading");
                modal.classList.remove("is-shown");
            }, 200);
        }
    }
}

document.addEventListener("click", externalUrl);
document.addEventListener("touchend", externalUrl);

document.addEventListener("click", closeSpeedbumpModal);
document.addEventListener("touchend", closeSpeedbumpModal);